// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Particle_Css = require("./Particle_Css.bs.js");
var Particle_Spacer_Ds = require("./Particle_Spacer_Ds.bs.js");

function makeInside(param) {
  var toRule = function (fn, spacerSizeOpt) {
    return Belt_Option.map(spacerSizeOpt, (function (spacerSize) {
                  return Curry._1(fn, Particle_Css.spacerSizeInside(spacerSize));
                }));
  };
  return Util_Array.catOption([
              toRule(CssJs.paddingTop, param.top),
              toRule(CssJs.paddingBottom, param.bottom),
              toRule(CssJs.paddingLeft, param.left),
              toRule(CssJs.paddingRight, param.right)
            ]);
}

function makeOutside(param) {
  var toRule = function (fn, spacerSizeOpt) {
    return Belt_Option.map(spacerSizeOpt, (function (spacerSize) {
                  return Curry._1(fn, Particle_Css.spacerSizeOutside(spacerSize));
                }));
  };
  return Util_Array.catOption([
              toRule(CssJs.marginTop, param.top),
              toRule(CssJs.marginBottom, param.bottom),
              toRule(CssJs.marginLeft, param.left),
              toRule(CssJs.marginRight, param.right)
            ]);
}

function toCss(spacerStyle) {
  var viewValues = Particle_Spacer_Ds.view(spacerStyle);
  switch (viewValues.TAG | 0) {
    case /* Inside */0 :
        return makeInside(viewValues._0);
    case /* Outside */1 :
        return makeOutside(viewValues._0);
    case /* Both */2 :
        var match = viewValues._0;
        return Belt_Array.concat(makeInside(match.inside), makeOutside(match.outside));
    
  }
}

exports.makeInside = makeInside;
exports.makeOutside = makeOutside;
exports.toCss = toCss;
/* CssJs Not a pure module */
